import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const saveToCloudMobilePublicHeader = isFeature('save-to-cloud-mobile-public-header');
